import React from "react";
import ReactApexChart from "react-apexcharts";
import "./MerchantDashboard.css";

function PayoutChart({ payoutStatistic }) {
  const successful = payoutStatistic?.payout?.payoutSucessfull || 0;
  const failed = payoutStatistic?.payout?.payoutFailed || 0;
  const pending = payoutStatistic?.payout?.payoutPending || 0;
  const totalTransactions = payoutStatistic?.payout?.payOutTotal || 0;

  const successRate = totalTransactions
    ? (successful / totalTransactions) * 100
    : 0;

  const data = [
    {
      id: 1,
      name: "Successful",
      percentValues: (successful / totalTransactions) * 100 || 0,
      color: "#00C49F",
      count: successful,
    },
    {
      id: 2,
      name: "Pending",
      percentValues: (pending / totalTransactions) * 100 || 0,
      color: "#F7B924",
      count: pending,
    },
    {
      id: 3,
      name: "Failed",
      percentValues: (failed / totalTransactions) * 100 || 0,
      color: "#FF8042",
      count: failed,
    },
  ];

  const series = [successful, pending, failed];

  const options = {
    chart: {
      height: 200,
      width: 200,
      type: "pie",
    },
    legend: {
      show: false,
      position: "bottom",
    },
    labels: ["Successful", "Pending", "Failed"],
    colors: ["#00C49F", "#F7B924", "#FF8042"],
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            show: false,
          },
        },
      },
    ],
  };

  return (
    <div>
      <div className="main-box">
        <div>
          <p className="heading-new">TOTAL WITHDRAWAL</p>
          <p
            className="merchant-users-1 sub-heading-new"
            style={{ color: "black" }}
          >
            {payoutStatistic?.payout?.payOutTotal || 0}
          </p>
        </div>

        <div>
          <div className="sucess-rate-1">
            <p>Success Rate:</p>
            <p>{Number(successRate).toFixed(2)}%</p>
          </div>
        </div>
      </div>

      <div className="trans-pie-mer">
        {payoutStatistic && (
          <div id="chart">
            <ReactApexChart
              options={options}
              series={series}
              type="pie"
              height={200}
              width={200}
            />
          </div>
        )}

        <div className="data-rate">
          {data.map((category) => (
            <div key={category.id} className="progress-card-category">
              <p
                className="square-box"
                style={{
                  backgroundColor: `${category.color}`,
                }}
              ></p>
              <p className="category-value">
                {category.name}: {category.count}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default PayoutChart;
